import {
  CForm,
  CFormGroup,
  CLabel,
  CModalBody,
  CModalFooter,
  CTextarea
} from "@coreui/react";
import { useForm } from "react-hook-form";
import { BasicInput, ButtonBasic } from "src/components";
import StyledModal from "src/components/BasicModal/BasicModal.style";

const AddModal = ({ onAdd, show, handleClose, isGlobal }) => {
  const { handleSubmit, setValue } = useForm();

  const onChange = (e) => {
    setValue(e.target.name, e.target.value, { shouldTouch: true });
  };

  const onSubmit = (data) => {
    onAdd(data);
    handleClose();
  };

  const subtitle = isGlobal
    ? `You will add a new global survey version and set it as default - new organisations will use it. Existing organisations will not be affected.`
    : "You will add a new survey version for organisation and set is as current.";

  return (
    <StyledModal show={show} onClose={handleClose} centered>
      <CForm onSubmit={handleSubmit(onSubmit)}>
        <CModalBody>
          <h4>Add new survey version</h4>
          <p className="text-info">{subtitle}</p>
          <CFormGroup>
            <CLabel>Label (optional)</CLabel>
            <BasicInput name="label" onChange={onChange} />
          </CFormGroup>
          <CFormGroup className="mt-4">
            <CLabel>Description (optional)</CLabel>
            <CTextarea name="description" onChange={onChange} rows={2} />
          </CFormGroup>
        </CModalBody>
        <CModalFooter>
          <ButtonBasic
            onClick={handleClose}
            type="button"
            bgcolor="var(--secondary)"
            hovercolor="var(--secondary-dark)"
          >
            Cancel
          </ButtonBasic>
          <ButtonBasic type="submit" bgcolor="green" hovercolor="darkgreen">
            Save
          </ButtonBasic>
        </CModalFooter>
      </CForm>
    </StyledModal>
  );
};

export default AddModal;
